import { useTranslation } from "react-i18next";
import { IconButton, Stack, SvgIconProps, Typography } from "@mui/material";
import { AddCircle, CheckCircleOutlined, RemoveCircle } from "@mui/icons-material";
import { useStyle } from "./style";

interface IParams {
    maxQuantity: number;
    counter: number;
    isLoading: boolean;
    showSubtitle?: boolean;
    iconColor?: SvgIconProps["color"];
    handleAddAddon(): void;
    handleRemoveAddon(): void;
}

export const AddonCounter = (props: IParams) => {
    const { counter, isLoading, showSubtitle, handleAddAddon, handleRemoveAddon, maxQuantity, iconColor } = props;
    const { t } = useTranslation("home", { keyPrefix: "broadbandAddon" });
    const { classes } = useStyle();

    const subtitle = t(counter === 1 ? "itemAddedToCartSingular" : "itemAddedToCartPlural", { counter });

    return (
        <Stack alignItems="center" data-testid="addon-counter" gap={1} width="100%">
            <div className={classes.counterContainer}>
                <div className={classes.fixedButtonContainer}>
                    {counter > 0 && (
                        <IconButton
                            className={classes.iconButton}
                            data-testid="remove-addon"
                            disabled={isLoading}
                            onClick={handleRemoveAddon}
                        >
                            <RemoveCircle className={classes.icon} color={iconColor ?? "primary"} />
                        </IconButton>
                    )}
                </div>
                <div className={classes.counter} data-testid="counter">
                    <Typography className={classes.counterText} color="secondary" textAlign="center">
                        {counter}
                    </Typography>
                </div>
                <div className={classes.fixedButtonContainer}>
                    {counter < maxQuantity && (
                        <IconButton
                            className={classes.iconButton}
                            data-testid="add-addon"
                            disabled={isLoading}
                            onClick={handleAddAddon}
                        >
                            <AddCircle className={classes.icon} color={iconColor ?? "primary"} />
                        </IconButton>
                    )}
                </div>
            </div>
            {counter > 0 && showSubtitle && (
                <Stack alignItems="center" direction="row" gap={0.5}>
                    <CheckCircleOutlined color="secondary" fontSize="small" />
                    <Typography color="secondary" variant="small">
                        {subtitle}
                    </Typography>
                </Stack>
            )}
        </Stack>
    );
};
